import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SermonCard } from "@/pages/SermonPages";

export default function Sermons() {
  const [sermons, setSermons] = useState([]);
  useEffect(() => { api.get("/sermons", { params: { limit: 6 } }).then(r => setSermons(r.data.items || [])).catch(() => {}); }, []);
  if (!sermons.length) return null;
  return <section id="sermons" className="py-24 lg:py-32 bg-[#F3EFEA]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10"><div className="flex flex-wrap items-end justify-between gap-4 mb-12">
      <div><div className="text-xs uppercase tracking-[0.2em] text-[#5C6661] mb-4">Grow in the word</div><h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#1C201E]">Sermons & Messages</h2></div>
      <Link to="/sermons" className="text-[#2C4C3B] underline">Browse all sermons</Link></div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">{sermons.map(s => <SermonCard key={s.id} sermon={s} />)}</div>
    </div>
  </section>;
}
